export const CONFIGURATION_REQUEST = 'CONFIGURATION_REQUEST'
export const CONFIGURATION_SUCCESS = 'CONFIGURATION_SUCCESS'
export const CONFIGURATION_FAILURE = 'CONFIGURATION_FAILURE'
export const LOGOUT = 'USER_LOGOUT'